










































































































































































import Vue from 'vue'
import { mapState } from 'vuex'

import { Tag } from '@/types/tag.d.ts'

import ToolbarSave from '@/components/icons/toolbar-save.vue'
import ToolbarRefresh from '@/components/icons/toolbar-refresh.vue'
import ToolbarDelete from '@/components/icons/toolbar-delete.vue'

import { Create, Delete, Patch } from '@/api/tags'
import { SelectOptions } from './types'

const excel = require('../../../utils/Export2Excel')

export default Vue.extend({
  name: 'TableTag',
  props: {
    devices: Array,
  },
  components: {
    ToolbarSave,
    ToolbarRefresh,
    ToolbarDelete,
  },
  data() {
    return {
      //----------------------------------------------------------------------------------------------------
      // Options
      //----------------------------------------------------------------------------------------------------
      optsDataType: [
        { value: 'bool', text: 'Boolean' },
        { value: 'int8', text: 'Short' },
        { value: 'uint8', text: 'Unsigned short' },
        { value: 'int16', text: 'Integer' },
        { value: 'uint16', text: 'Unsigned integer' },
        { value: 'int32', text: 'Long' },
        { value: 'uint32', text: 'Unsigned long' },
        { value: 'float32', text: 'Float 32' },
        { value: 'float64', text: 'Float 64' },
      ],
      optsDevice: [] as SelectOptions[],

      // tags: [] as Tag[],
      newTag: {} as Tag,
      selectedTag: {} as Tag,
      selectedId: -1,
    }
  },

  computed: {
    ...mapState('tag', { tags: 'items' }),
  },

  methods: {
    //-------------------------------------------------------------------------------------------------
    // Inisialisasi
    //-------------------------------------------------------------------------------------------------
    initNewRow() {
      this.newTag.id = 0
      this.newTag.uid = ''
      this.newTag.name = ''
      this.newTag.address = ''
      // eslint-disable-next-line
      this.newTag.deviceId = 0
      this.newTag.description = ''
    },

    //-------------------------------------------------------------------------------------------------
    // Database operations
    //-------------------------------------------------------------------------------------------------
    async create(tag: Tag) {
      await Create(tag)
    },
    async find() {
      await this.$store.dispatch('tag/get')
    },

    async patch(id: number, tag: Tag) {
      await Patch(id, tag)
    },

    async delete(id: number) {
      await Delete(id)
    },

    //-------------------------------------------------------------------------------------------------
    // Event pada mouse & keyboard
    //-------------------------------------------------------------------------------------------------
    onRowClicked(tag: Tag) {
      this.selectedId = tag.id
      this.selectedTag = tag
    },
    onRowContextMenu(tag: Tag) {
      this.selectedId = tag.id
      this.selectedTag = tag
    },

    async onRowEnterKeyUp(tag: Tag) {
      await this.patch(tag.id, tag)
      await this.find()
    },

    async onNewRowEnterKeyUp() {
      await this.create(this.newTag)
      this.initNewRow()
      await this.find()
    },

    //-------------------------------------------------------------------------------------------------
    // Toolbar
    //-------------------------------------------------------------------------------------------------

    onToolbarRefresh() {
      this.find()
    },

    async onToolbarSave() {
      if (this.selectedId == -1) return

      await this.patch(this.selectedId, this.selectedTag)
    },

    onToolbarExport2Excel() {
      // eslint-disable-next-line
      const data = [] as any[]
      for (const i in this.tags) {
        const t = JSON.parse(JSON.stringify(this.tags[i]))
        const d = this.optsDevice.find((el) => el.value == t.deviceId)

        if (d != undefined) {
          t.device = d.text
        }

        data.push(t)
      }

      const header = {
        name: 'Name',
        device: 'Device',
        type: 'Data type',
        address: 'Address',
        description: 'Description',
      }
      const filename = 'Tags_' + new Date().getTime()

      excel.json2excel(filename, data, header)
    },

    /**
     * Tampilkan dialog konfirmasi penghapusan tag ketika tombol delete pada toolbar di-klik
     * jika selectedId bukan -1
     */
    onToolbarDelete() {
      if (this.selectedId == -1) {
        return
      }

      // eslint-disable-next-line
      ;(this as any).$refs.dialogDelete.show()
    },

    //-------------------------------------------------------------------------------------------------
    // Dialogs
    //-------------------------------------------------------------------------------------------------
    async onDialogDeleteOk() {
      await this.delete(this.selectedId)
      await this.find()
    },

    //-------------------------------------------------------------------------------------------------
    // De..
    //-------------------------------------------------------------------------------------------------

    // eslint-disable-next-line
    readableValue(v: any): any {
      if (typeof v == 'number') {
        if (v % 1 == 0) {
          return v
        }
        return v.toFixed(4)
      }

      return v
    },
  },

  watch: {
    devices: function(value: SelectOptions[]) {
      this.optsDevice = value
    },

    /**
      Pantau perubahan selectedId.
      Jika selectedId berubah, trigger even onSelectedIdChanged dan kirimkan id baru sebagai payload.
     */
    selectedId: function(value: number) {
      this.$emit('onSelectedIdChanged', value)
    },

    selectedTag: function(value: Tag) {
      this.$emit('selectedChanged', value)
    },
  },

  async created() {
    await this.find()
  },
})
